import {date} from '@priority-software/priority-utils/lib/date';
import {getDateFormat} from '../../../../Localization/date';

type PriorityDate = {
    year: number;
    month: number;
    day: number;
    hours?: number;
    minutes?: number;
};

export const getFormattedDateTime = (Value: PriorityDate, type: 'date' | 'time', code: string) => {
    if (!Value) return '';
    const {year = 0, day = 0, month = 0, minutes = 0, hours = 0} = Value;
    const format = getDateFormat(type, code);

    const monthIndex = month === 0 ? month : month - 1;
    const dateObj = new Date(year, monthIndex, day, hours, minutes, 0);

    return date(dateObj, format);
};
